var _defs, _path, _circle, _circle2, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff9000;}.cls-2{fill:#404080;}.cls-3{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M410,490a159.54,159.54,0,0,1-46.86,113.14l-119,119.05a26.67,26.67,0,0,1-37.72-37.71l34.72-34.73A160,160,0,1,1,410,490Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 250,
    cy: 490,
    r: 115.56
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 250,
    cy: 490,
    r: 62.22
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M391.14,593.43l37.72,37.71a26.68,26.68,0,0,1,0,37.72h0a26.68,26.68,0,0,1-37.72,0l-37.71-37.72a26.63,26.63,0,0,1-5.2-30.34l-32.51-32.51,12.57-12.57,32.51,32.51a26.68,26.68,0,0,1,30.34,5.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M881.19,438.74,776.62,543.33h86.72A26.67,26.67,0,0,1,890,570h0a26.67,26.67,0,0,1-26.66,26.67H712.25A26.67,26.67,0,0,1,685.58,570h0a26.56,26.56,0,0,1,7.82-18.85L799,445.56H712.25a26.67,26.67,0,0,1-26.67-26.67h0a26.67,26.67,0,0,1,26.67-26.67H863.34A26.67,26.67,0,0,1,890,418.89h0a26.52,26.52,0,0,1-8.3,19.32C881.54,438.39,881.36,438.57,881.19,438.74Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M693.31,551.21l.09-.08A26.56,26.56,0,0,0,685.58,570v1.24A26.49,26.49,0,0,1,693.31,551.21Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M713.55,596.64q-1.26.06-2.55,0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M641.11,596.67h0A26.67,26.67,0,0,1,614.44,570h0a26.67,26.67,0,0,1,26.67-26.67h0A26.67,26.67,0,0,1,667.78,570h0A26.67,26.67,0,0,1,641.11,596.67Zm26.67-97.78V392.22a26.66,26.66,0,0,0-26.67-26.66h0a26.66,26.66,0,0,0-26.67,26.66V498.89a26.67,26.67,0,0,0,26.67,26.67h0A26.67,26.67,0,0,0,667.78,498.89Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M490,596.67h0A106.67,106.67,0,0,1,383.33,490V418.89A26.67,26.67,0,0,1,410,392.22h0a26.67,26.67,0,0,1,26.67,26.67V490A53.32,53.32,0,0,0,490,543.33h0A53.32,53.32,0,0,0,543.33,490V418.89A26.67,26.67,0,0,1,570,392.22h0a26.67,26.67,0,0,1,26.67,26.67V490A106.67,106.67,0,0,1,490,596.67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e2aca5add74f2700e3cc07dc6249ec2f.svg";
export { ForwardRef as ReactComponent };